import React, { useState } from "react";
import { useGetZoneCounterListforProductInv } from "../../../apiclient/transaction/useGetZoneCounterApi";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { GroupDescriptor, process } from "@progress/kendo-data-query";
import { LoadingIndicator } from "../../../core/loading-indicator.component";
import ZoneCounterModel from "../../../models/transaction/zonecounter-model";
import AgentOrderEntryPage from "./agentorder-entry";

const AgentOrderPage: React.FC = () => {
    const { data: result, isLoading, isError } = useGetZoneCounterListforProductInv();
    const [group, setGroup] = useState<GroupDescriptor[]>([{ field: "name" }]);
    const [editData, setEditData] = useState<ZoneCounterModel | null>(null);
    const [activePage, setActivePage] = useState<"list" | "entry">("list");

    // Format date as dd-MMM-yyyy
    const formatDate = (date: Date): string => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // Handle edit
    const handleEditCounter = (dataItem: ZoneCounterModel) => {
        const currentDate = new Date();
        const formattedDate = formatDate(currentDate);
        setEditData({ ...dataItem, currentDate: formattedDate });
        setActivePage("entry");
    };

    // Cancel entry
    const handleCancelEntry = () => {
        setEditData(null);
        setActivePage("list");
    };

    // Custom group header renderer to show zoneName instead of zoneId
    const ZoneGroupHeader = (props: any) => {
        const groupItems = props.dataItems as ZoneCounterModel[];
        const zoneName = groupItems?.[0]?.zoneName ?? props.value;
        return <strong style={{ paddingLeft: 10 }}>{zoneName}</strong>;
    };

    // Process and expand all group rows
    const flatData = result || [];
    const processed = process(flatData, { group });
    const gridData = {
        ...processed,
        data: processed.data.map((groupItem: any) => ({
            ...groupItem,
            expanded: true,
        })),
    };
    console.log('flatData', flatData);


    if (isLoading) return <LoadingIndicator isLoading={isLoading} />;
    if (isError) return <div>Error loading data</div>;

    return (
        <div className="card p-3 border-0 m-3 sw-shadow radius-15">
            <center>
                <h4 className="text-normal title-web mb-0 report-title-color">AGENT ORDERS</h4>
            </center>

            {activePage === "entry" && editData ? (
                <AgentOrderEntryPage
                    data={editData}
                    onClose={handleCancelEntry}
                    setActivePage={setActivePage}
                />
            ) : (
                <Grid
                    style={{ height: "auto" }}
                    data={gridData}
                    groupable
                    group={group}
                    onGroupChange={(e) => setGroup(e.group)}
                >
                    {/* Group by Zone ID, use custom group header to show zone name */}
                    {/*   <GridColumn field="name" title="Zone" headerCell={ZoneGroupHeader} /> */}
                    <GridColumn field="name" title="Zone" />
                    {/* Counter Name with edit button */}
                    <GridColumn
                        field="counterName"
                        title="Counter Name"
                        cell={(props) => {
                            if (props.dataItem && props.dataItem.hasOwnProperty('counterName')) {
                                return (
                                    <td>
                                        <button
                                            className="action-btns k-grid-edit-command"
                                            onClick={() => handleEditCounter(props.dataItem)}
                                            style={{
                                                padding: "5px 10px",
                                                fontSize: "14px",
                                                backgroundColor: "#756fe3",
                                                border: "none",
                                                borderRadius: "5px",
                                                color: "#fff",
                                                cursor: "pointer",
                                            }}
                                        >
                                            {props.dataItem.counterName}
                                        </button>
                                    </td>
                                );
                            }

                            // Default rendering for group rows or undefined
                            return <td>{props.dataItem?.counterName || ""}</td>;
                        }}

                    // cell={(props) => (
                    //     <td>
                    //         <button
                    //             className="action-btns k-grid-edit-command"
                    //             onClick={() => handleEditCounter(props.dataItem)}
                    //             style={{
                    //                 padding: "5px 10px",
                    //                 fontSize: "14px",
                    //                 backgroundColor: "#756fe3",
                    //                 border: "none",
                    //                 borderRadius: "5px",
                    //                 color: "#fff",
                    //                 cursor: "pointer",
                    //             }}
                    //         >
                    //             {props.dataItem.counterName}
                    //         </button>
                    //     </td>
                    // )}
                    />

                    {/* Login Users column */}
                     <GridColumn field="loginUsers" title="Login Users" />
                </Grid>
            )}
        </div>
    );
};

export default AgentOrderPage;
